/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Task_Analysis_Status_LabelInputs */

const en_task_analysis_status_label = /** @type {(inputs: Task_Analysis_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "pending") return /** @type {LocalizedString} */ (`AI Analysis in progress...`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Analysis Failed`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_task_analysis_status_label = /** @type {(inputs: Task_Analysis_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "pending") return /** @type {LocalizedString} */ (`Análise da IA em andamento...`);
	if (i?.status === "failed") return /** @type {LocalizedString} */ (`Falha na Análise`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "pending" | "AI Analysis in progress..." |
* | "failed" | "Analysis Failed" |
* | * | "{status}" |
*
* @param {Task_Analysis_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_analysis_status_label = /** @type {((inputs: Task_Analysis_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Analysis_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_analysis_status_label(inputs)
	return pt_br2_task_analysis_status_label(inputs)
});